<template>
  <!-- out which, I am only applying Bootstrap to pages which use it -->

  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH"
    crossorigin="anonymous"
  />
  <!-- See: `getFullVh()` -->
  <div style="overflow: hidden; height: 0">
    <div id="measure-vh" style="position: fixed; height: 100vh"></div>
  </div>

  <!-- showPopUpOk --><transition name="fade">
    <div
      v-show="showPopUpOk"
      class="modal-overlayfrombottomblur"
      :class="this.showOld === true ? 'wrapper-todiv' : 'wrapper-todiv-new'"
      style="z-index: 999"
    >
      <div
        class="modalnotbootstrap"
        style="
          padding-top: 3vh;
          padding-bottom: 3vh;
          min-height: 40vh;
          width: 80%;
        "
      >
        <!-- put in table for dev speed need to learn more about flex -->
        <table border="0" width="80%">
          <tr>
            <td>
              <div
                class="lt-blue txtc"
                :style="{
                  'font-size': this.fontSizeTitle + 'vh',
                  'line-height': this.fontSizeTitleLineHeight + 'vh',
                }"
              >
                {{ this.popUpMsgTitle }}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div
                class="lt-blue txtc"
                :style="{
                  'font-size': this.fontSizePopUpMsg + 'vh',
                  'line-height': this.fontSizePopUpMsgLineHeight + 'vh',
                  'padding-top': '1vh',
                }"
                style="overflow-wrap: anywhere"
              >
                {{ this.popUpMsgBody }}
              </div>
            </td>
          </tr>
          <tr v-show="!this.suppressOk">
            <td style="height: 10vh">
              <div>
                <button
                  class="widebtn"
                  ref="show-popup-ok"
                  style="width: 50%; height: 6vh"
                  @click="this.doPopUpOk()"
                >
                  Ok
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <!-- spacer -->
            <td><div></div></td>
          </tr>
        </table>
      </div>
    </div>
  </transition>
  <div>
    <!-- how or dont show whole new home page -->

    <div
      class="container text-center"
      style="padding: 0vw; outline: 0.0em dashed orange"
    >
      <NavigationBar
        @do-show-home="doShowHome"
        @do-show-gettipsstart="doShowGetTipsStartNew"
        @do-show-givetips="doGiveTipsShowMoreInfoNew"
        @do-show-gettips="doGetTipsShowMoreInfoNew"
        @do-show-tipwithoutscanning="doShowTipWithoutScanning"
        @do-show-account="doShowAccount"
        @do-download-brochure="doDownloadBrochure"
        @do-show-contact="doShowContactNew"
      />

      <div
        class="jumbotron text-center tugradient1"
        style="outline: 0.0em dashed red"
      >
        <div
          class="container mediaSelectDesktop"
          style="padding: 3vw; outline: 0.0em dashed blue"
        >
          <div class="row" style="outline: 0.0em dashed pink">
            <div v-if="this.nhbfmembers === true"
              class="offset-md-4 col-md-8 tufont tublue tumediumtitlebold tubestsolutiontitle text-middle"
              style="outline: 0.0em dashed purple; height: 60px "
            >
              Welcome NHBF member...
            </div>
            <div
              class="col-md-4 mainimageheight hairdresser2imagewidth "
              style="display: flex; flex-wrap: wrap; outline: 0.0em dashed green"
            >
              <img
                class="hairdresser2imagewidth fade-in-button-animation"
                style="
                  height: auto;
                  padding-top: 0vw;
                  padding-bottom: 1.5vw;
                  outline: 0.0em dashed purple;
                "
                alt="Hairdresser"
                src="../assets/hairdresser2.webp"
              />
              <span class="mediaSelectDesktop tufont tusmallerfontsize">
                If one of our standard packages below does not suit your
                needs, simply let us know your requirements.</span
              >
            </div>

            <!-- <div class="col-sm-8 col-md-8 text-start" style="padding-left: 3vw; padding-right: 6vw; outline:0.0em dashed orange; height: auto"> -->

            <div
              class="col-8 col-md-8 tufont tumediumtitlebold tubestsolutiontitle text-middle transparent-simple-animation"
              style="outline: 0.0em dashed purple; height: auto"
            >
              Getting set up with ThankU is this easy!
            </div>
            <HomePageTickedListItem
              ListItemString="Decide below which ThankU QR media you would like"
            />
            <HomePageTickedListItem
              :ListItemString="useNewOrderForm ? 'Click a \'Get set up!\' button to proceed with your order' : 'Click a \'Get set up for free!\' button, for your media at no cost'"
            />
            <HomePageTickedListItem
              ListItemString="Complete the form below to tell us your selection and where to send the media"
            />
            <HomePageTickedListItem
              ListItemString="We send you your ThankU QR media by post, and a staff set up email"
            />
            <HomePageTickedListItem
              ListItemString="Staff connect themselves to get ready for tips in 1 minute each"
            />
          </div>
          <br />

          <div
            class="row col-sm-12 col-md-8 offset-md-4 tufont tutablepadding text-start tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-10 offset-md-1 tufont;"
              style="outline: 0.0em dashed green"
            >
              <div
                class="bottombuttonwidth"
                style="padding-top: 1vh; margin: auto"
              >
                <span></span
                ><button
                  class="tuhomepagesignupbutton turegularfontsize fade-in-button-animation"
                  style="width: 100%"
                  @click="this.doOrderBadges()"
                >
                  {{ useNewOrderForm ? 'Get set up!' : 'Get set up for free!' }}
                </button>
              </div>
            </span>
          </div>
          <div class="mediaSelectDesktop">
            <div
              class="container"
              style="padding: 3vw; outline: 0.0em dashed blue"
            >
              <div class="row" style="outline: 0.0em dashed pink"></div>
            </div>
            <div class="row" style="height: 0vw !important">
              <div class="col-md-1" style="outline: 0.0em dashed green">
                <img
                  class="smile1"
                  alt="ThankU smile right"
                  src="../assets/tusmileonly.png"
                />
              </div>
              <div class="col-md-1" style="outline: 0.0em dashed green">
                <img
                  class="smile2"
                  alt="ThankU smile right"
                  src="../assets/tusmileonly.png"
                />
              </div>
            </div>
          </div>
          <div
            class="row col-sm-12 col-md-8 offset-md-4 tufont tutablepadding text-center tusmallerfontsize"
            style="
              outline: 0.0em dashed red;
              height: auto;
              padding-top: 1vh;
              margin-top: -6vw;
            "
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="padding-top: 1.5vw; outline: 0.0em dashed green"
            >
              <template v-if="!useNewOrderForm">
                ThankU is currently providing its ThankU QR badge media to you
                <b>free of charge</b> for a limited time only on your first order. Simply tell us how
                many of each format you would like, and the address to send them
                to - that's it!
              </template>
              <template v-else>
                Select your ThankU QR badge media below and we'll send it to you promptly. 
                Simply choose what you need and complete your order!
              </template>
            </span>
          </div>
          <div
            class="row col-sm-12 col-md-8 offset-md-4 tufont tutablepadding text-center tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="padding-top: 0vw; outline: 0.0em dashed green"
            >
              Fees are payable on tip transactions, most often paid by the
              tipper, but when not, fees are deducted from the tip. For FAQ on
              recieving tips, please see
              <span
                class="text-only-button-new cancel"
                @click="doGetTipsShowMoreInfoNew()"
                style="pointer: cursor"
                ><b>here</b></span
              >, and full information specifically on fees, please see
              <span
                class="text-only-button-new cancel"
                @click="doGetTipsShowMoreInfoFeesNew()"
                style="pointer: cursor"
                ><b>here</b></span
              >.
            </span>
            <div
              class="col-12 tufont tutablepadding tusmallerfontsize"
              style="
                outline: 0.0em dashed red;
                height: auto;
                float: left;
                padding-top: 1vh;
              "
            >
              <button
                class="tuhomepagebutton turegularfontsize fade-in-button-animation"
                @click="this.doDownloadBrochure()"
              >
                Download our brochure
              </button>
            </div>
          </div>
        </div>
        <div
          class="container mediaSelectPhone"
          style="padding: 3vw; outline: 0.0em dashed blue"
        >
          <div class="mediaSelectPhone container">
            <div class="row" style="display: none; outline: 0.0em dashed pink">
              <div
                class="offset-0 col-3"
                style="height: 0px; outline: 0.0em dashed green"
              >
                <img
                  class="smile1"
                  style="outline: 0.5em dashed green"
                  alt="ThankU smile"
                  src="../assets/tusmileonly.png"
                />
              </div>

              <div>&nbsp;</div>

              <div
                class="offset-0 col-12 float-right"
                style="height: 0px; outline: 0.0em dashed green"
              >
                <img
                  class="smile2"
                  alt="ThankU smile"
                  src="../assets/tusmileonly.png"
                />
              </div>
            </div>
          </div>
          <div v-if="this.nhbfmembers === true"
            class="col-12 tufont tublue tumediumtitlebold tubestsolutiontitle text-middle"
            style="outline: 0.0em dashed purple; height: 60px "
          >
            Welcome NHBF member...
          </div>
          <div
            class="row"
            style="display: flex; flex-wrap: wrap; outline: 0.0em dashed pink"
          >
            <div
              class="col-7 offset-0 mainimageheight hairdresser2imagewidth"
              style="display: flex; flex-wrap: wrap; outline: 0.0em dashed green"
            >
              <img
                class="hairdresser2imagewidth fade-in-button-animation"
                style="
                  height: auto;
                  padding-top: 0vw;
                  padding-bottom: 1.5vw;
                  outline: 0.0em dashed purple;
                "
                alt="Hairdresser"
                src="../assets/hairdresser2.webp"
              />
              <span class="mediaSelectDesktop tufont tusmallerfontsize">
                <br />If one of our standard packages below does not suit your
                needs, simply let us know your requirements.</span
              >
            </div>

            <div
              class="col-5 tufont tumediumtitleboldbigger text-middle transparent-simple-animation"
              style="
                outline: 0.0em dashed purple;
                padding-left: 0vw;
                height: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              Getting set up with ThankU is this easy!
            </div>

            <!-- <div class="col-sm-8 col-md-8 text-start" style="padding-left: 3vw; padding-right: 6vw; outline:0.0em dashed orange; height: auto"> -->

            <HomePageTickedListItem
              ListItemString="Decide below which ThankU QR media you would like"
            />
            <HomePageTickedListItem
              :ListItemString="useNewOrderForm ? 'Click a \'Get set up!\' button to proceed with your order' : 'Click a \'Get set up for free!\' button, for your media at no cost'"
            />
            <HomePageTickedListItem
              ListItemString="Complete the form below to tell us your selection and where to send the media"
            />
            <HomePageTickedListItem
              ListItemString="We send you your ThankU QR media by post, and a staff set up email"
            />
            <HomePageTickedListItem
              ListItemString="Staff connect themselves to get ready for tips in 1 minute each"
            />
          </div>
          <br />

          <div
            class="row col-12 col-md-8 offset-md-4 tufont tutablepadding text-start tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-10 offset-md-1 tufont;"
              style="outline: 0.0em dashed green"
            >
              <div
                class="bottombuttonwidth"
                style="padding-top: 1vh; margin: auto"
              >
                <span></span
                ><button
                  class="tuhomepagesignupbutton turegularfontsize fade-in-button-animation"
                  style="width: 100%"
                  @click="this.doOrderBadges()"
                >
                  {{ useNewOrderForm ? 'Get set up!' : 'Get set up for free!' }}
                </button>
              </div>
            </span>
          </div>
          <div
            class="row col-12 col-md-8 offset-md-4 tufont text-center tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="
                padding-top: 1.5vw;
                padding-left: 0vw;
                padding-right: 0vw;
                outline: 0.0em dashed green;
              "
            >
              <template v-if="!useNewOrderForm">
                ThankU is currently providing its ThankU QR badge media to you
                <b>free of charge</b> for a limited time only. Simply tell us how
                many of each format you would like, and the address to send them
                to - that's it!
              </template>
              <template v-else>
                Select your ThankU QR badge media below and we'll send it to you promptly. 
                Simply choose what you need and complete your order!
              </template>
            </span>
          </div>
          <div
            class="row col-12 col-md-8 offset-md-4 tufont text-center tusmallerfontsize"
            style="outline: 0.0em dashed red; height: auto; padding-top: 1vh"
          >
            <span
              class="col-9 offset-2 col-md-6 offset-md-3 tufont;"
              style="
                padding-top: 1.5vw;
                padding-left: 0vw;
                padding-right: 0vw;
                outline: 0.0em dashed green;
              "
            >
              Fees are payable on tip transactions, most often paid by the
              tipper, but when not, fees are deducted from the tip. For FAQ on
              recieving tips, please see
              <span
                class="text-only-button-new cancel"
                @click="doGetTipsShowMoreInfoNew()"
                style="pointer: cursor"
                ><b>here</b></span
              >, and full information specifically on fees, please see
              <span
                class="text-only-button-new cancel"
                @click="doGetTipsShowMoreInfoFeesNew()"
                style="pointer: cursor"
                ><b>here</b></span
              >.
            </span>
          </div>
          <div
            class="col-12 tufont tusmallerfontsize"
            style="
              outline: 0.0em dashed red;
              height: auto;
              padding-top: 1vh;
              padding-left: 0vw;
              pading-right: 0vw;
              outline: 0.0em dashed green;
            "
          >
            <button
              class="tuhomepagebutton turegularfontsize tugettipspagebuttonwidth fade-in-button-animation"
              @click="this.doDownloadBrochure()"
            >
              Download our brochure
            </button>
          </div>
        </div>
        <div class="container" style="padding-top: 1vw">
          <div class="row">
            <div
              class="col-12 offset-0 col-md-12 offset-md-0 tuwhitebox"
              style="width: 90vw; margin: auto; outline: 0.0em dotted black"
            >
              <div class="tufont tumediumtitlebold">Regular package</div>
              <div
                class="col-md-8 offset-md-2 tufont tusmallerfontsize"
                style="padding-top: 1vw; padding-bottom: 1vw"
              >
                This package is widely used in salons, however we have a number
                of options other than 'stylist', including 'therapist',
                'technician', 'nail technician, 'nail tech', 'nail stylist', 'artist', 'host', 'waiter', 'bar staff', 'driver', 'team', 'guide', 'trainer', or
                non-specific.
              </div>
              <div
                class="container"
                style="
                  display: flex;
                  flex-wrap: wrap;
                  outline: 0.0em dashed green;
                "
              >
                <div class="col-12 col-md-6" style="outline: 0.0em dashed pink">
                  <table
                    class="table"
                    border="0"
                    style="width: 100%; outline: 0.0em dashed red"
                  >
                    <tr>
                      <td
                        style="padding-bottom: 0.2vw; outline: 0.0em dashed pink"
                      >
                        Front Desk Stand
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 1vw; outline: 0.0em dashed red">
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          Typically placed at your reception / payments desk,
                          our stylish Front Desk Stand announces to your clients
                          that you have a tipping service available for them.
                          Dimensions: 14.8 x 10.5cm.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a v-bind:href="frontdeskfull"
                          ><img
                            class="productImageWidth"
                            style="
                              height: auto;
                              padding-top: 0vw;
                              outline: 0.0em dashed purple;
                            "
                            alt="Window sticker"
                            src="../assets/frontdesklessrounded.webp"
                          />
                        </a>
                      </td>
                    </tr>
                  </table>
                </div>

                <div class="col-12 col-md-6" style="outline: 0.0em dashed red">
                  <table
                    class="table"
                    border="0"
                    style="width: 100%; outline: 0.0em dashed red"
                  >
                    <tr>
                      <td
                        style="padding-bottom: 0.2vw; outline: 0.0em dashed pink"
                      >
                        <b>Optional:</b> "No Glue" Mirror Sticker
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 1vw; outline: 0.0em dashed red">
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          <b>At your option:</b> mount our "No Glue" Mirror
                          Stickers on the mirror in front of the client. Some
                          salons choose this option, others do not, it's a
                          matter of personal preference.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a v-bind:href="stickerfull"
                          ><img
                            class="productImageWidth"
                            style="
                              height: auto;
                              padding-top: 0vw;
                              outline: 0.0em dashed purple;
                            "
                            alt="Window sticker"
                            src="../assets/stickerrounded.webp"
                          />
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 2vw;
                          padding-bottom: 1vw;
                          outline: 0.0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          <b>How to mount:</b> adheres to the surface of
                          client-facing mirror without adhesive and is easily
                          removable – simply moisten glass of mirror with damp
                          kitchen roll or similar, then mount the 'sticker' on
                          the glass, gently pressing out any obvious bubbles
                          with your finger – dab any remaining moisture on the
                          surface of the sticker or mirror away if necessary.
                          Dimensions: 12cm x 8cm.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 2vw;
                          padding-bottom: 1vw;
                          outline: 0.0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          <b
                            >We also have wristworn and stickable ThankU QR
                            media, please phone or email us to find out more.</b
                          >
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-1"></div>
            <div
              class="col-md-6 offset-md-2 tuwhitebox discreetpackagephonewidth"
              style="margin-top: 3vw !important; padding-top: 1vw; outline: 0.0em dotted black"
            >
              <div class="tufont tumediumtitlebold" style="padding-bottom: 1vw">
                Discrete package
              </div>

              <div class="container">
                <div class="col-12 col-md-12" style="outline: 0.0em dashed red">
                  <table
                    border="0"
                    style="width: 100%; outline: 0.0em dashed red"
                  >
                    <tr>
                      <td style="padding-bottom: 1vw">Tabletop Stand</td>
                    </tr>

                    <tr>
                      <td style="padding-bottom: 1vw; outline: 0.0em dashed red">
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          If you just want to keep the presentation of thankU
                          very discreet, use our sleek Tabletop Stand instead of
                          the Front Desk Stand, which you can direct your
                          clients to if they ask how they can tip. Dimensions:
                          6cm x 4.3cm.
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <a v-bind:href="countersquarefull"
                          ><img
                            class="productImageWidthCountertop"
                            style="
                              height: auto;
                              padding-top: 0vw;
                              outline: 0.0em dashed purple;
                            "
                            alt="Window sticker"
                            src="../assets/countersquarerounded.webp"
                          />
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 2vw;
                          padding-bottom: 1vw;
                          outline: 0.0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          We supply up to 3 Tabletop Stands at no charge.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          padding-top: 0.3vw;
                          padding-bottom: 1vw;
                          outline: 0.0em dashed red;
                        "
                      >
                        <div
                          class="col-md-8 offset-md-2 tufont tusmallestfontsize"
                          style="outline: 0.0em dashed brown"
                        >
                          <b
                            >We also have wearable and stickable ThankU QR
                            media, based on the blue ThankU QR badge shown above
                            - please phone or email us to find out more.</b
                          >
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref="orderForm"></div>
       
        
        <!-- OLD ORDER FORM -->
        <div
          v-show="!useNewOrderForm && this.showOrderForm === true"
          class="col-md-8 offset-md-2 tugreybluebox orderformphonewidth"
          style="margin-top: 3vw !important; outline: 0.0em dotted black"
        >
          <table style="width: 100%; "> <!-- background: #6bc720 -->
            <tr>
              <td>
                <div class="tufont tumediumtitlebold">
                  Order your free ThankU QR media
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="tufont tusmallerfontsize">
                  <!-- We currently supply your <u>first</u> order at no cost, if you would like <br /> to place an additional media order, please <a href="#" @click.prevent="doToggleToPaidForm">click here</a>. -->
                  We currently supply your <u>first</u> order at no cost, if you would like to place an additional media order, please use this form and we will supply you with a quotation.
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%; "
                      ref="changePackage"
                      @change="doDetectSelectChangePackage()"
                    >
                      <option value="regular">
                        -- Choose ThankU QR media package --
                      </option>
                      <option value="regular">
                        Regular ThankU QR media package
                      </option>
                      <option value="discreet">
                        Discreet ThankU QR media package
                      </option>
                      <option value="custom">
                        Custom - tell us in the Notes box below
                      </option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="changeBusinessType"
                      @change="doDetectSelectChangeBusinessType()"
                    >
                      <option value="salon">
                        -- Select your business type --
                      </option>
                      <option value="salon">Salon</option>
                      <option value="hotel">Hotel</option>
                      <option value="restaurant">Restaurant</option>
                      <option value="pub">Pub</option>
                      <option value="other">Other</option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="changeDescriptionRecipient"
                      @change="doDetectSelectChangeDescriptionRecipient()"
                    >
                      <option value="stylist">
                        -- Select description for main type of recipient --
                      </option>
                      <option value="stylist">Stylist</option>
                      <option value="therapist">Therapist</option>
                      <option value="technician">Technician</option>
                      <option value="nailtechnician">Nail Technician</option>
                      <option value="nailtech">Nail Tech</option>
                      <option value="nailstylist">Nail Stylist</option>
                      <option value="artist">Artist</option>
                      <option value="host">Host</option>
                      <option value="waiter">Waiter</option>
                      <option value="barstaff">Bar Staff</option>
                      <option value="driver">Driver</option>
                      <option value="team">Team</option>
                      <option value="guide">Guide</option>
                      <option value="trainer">Trainer</option>
                      <option value="non-specific">Non-specific</option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr v-show="this.showStickers === true">
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="changeNumberOfStickers"
                      @change="doDetectSelectChangeNumberOfStickers()"
                    >
                      <option value="0">
                        -- Select number of "No Glue" Mirror Stickers --
                      </option>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">More than 30</option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr v-show="this.showTableTop === true">
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <select
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="changeNumberOfTabletopStands"
                      @change="doDetectSelectChangeNumberOfTabletopStands()"
                    >
                      <option value="regular">
                        -- Select number of Tabletop Stands --
                      </option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">More than 3</option>
                    </select>
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 12vh; display: flex; padding-bottom: 0vw"
                  >
                    <textarea
                      type="textbox"
                      class="tugettipspage-textbox input"
                      style="height: 12vh; max-width: 100%; width: 100%"
                      ref="orderNotes"
                      placeholder="Notes - if you need to let us know more about your requirements."
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="textbox"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderName"
                      placeholder="Your name"
                    />
                  </span>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="textbox"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderBusinessName"
                      placeholder="Name of your business"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <textarea
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%; resize: none;"
                      ref="orderAddress"
                      placeholder="Address to send your ThankU QR media package to"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="email"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderEmail"
                      placeholder="Your email address"
                    />
                  </span>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    outline: 0.0em dashed red;
                  "
                >
                  <span
                    class="col-10 offset-1 col-md-8 offset-md-2"
                    style="height: 6vh; display: flex; padding-bottom: 0vw"
                  >
                    <input
                      type="textbox"
                      class="tugettipspage-textbox input"
                      style="max-width: 100%; width: 100%"
                      ref="orderPhoneNumber"
                      placeholder="Optional: your phone number"
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td style="display: flex">
                <div
                  class="lt-blue notes-text"
                  style="width: 90%; padding-top: 0vw"
                >
                  Your email address and phone number are <b>never</b> shared
                  with anyone
                </div>
                <br />
              </td>
            </tr>

            <tr>
              <td style="display: flex">
                <div
                  class="lt-blue notes-text"
                  style="width: 90%; padding-top: 0vw"
                >
                  <b>Any questions?</b> Please call us on +442078560378 or email
                  us at
                  <a
                    href="mailto:mailorders@thanku.app?subject=get ThankU enquiry&body=Please let us know your query or requirements: %0D%0A%0D%0A%0D%0AThank you! best wishes, the ThankU Team"
                    >mailorders@thanku.app</a
                  >
                </div>
                <br />
              </td>
            </tr>
            <tr>
              <td style="height: 12vh">
                <div>
                  <button
                    class="tuhomepagebutton tugettipspagebuttonwidth"
                    @click="this.doSubmitOrder()"
                  >
                    Submit your order
                  </button>
                </div>
              </td>
            </tr>
          </table>
        </div>

        <!-- NEW ORDER FORM -->
        <div
          v-show="useNewOrderForm && this.showOrderForm === true"
          class="new-order-form-container"
        >
          <div class="new-order-form">
            <h2 class="form-title">Build Your Order</h2>
            
            <div class="order-items">
              <!-- Front Desk Stand -->
              <div class="order-item" :class="{ 'item-selected': orderItems.frontDesk.quantity > 0 }">
                <div class="item-image" @click="openImageLightbox(require('@/assets/pos2croppedsm2.webp'))" style="cursor: pointer;">
                  <img src="../assets/pos2croppedsm2.webp" alt="Front Desk Stand">
                </div>
                <div class="item-details">
                  <h3 class="item-name">Front Desk Stand</h3>
                  <p class="item-description">Stylish stand for your reception desk (14.8 x 10.5cm)</p>
                  <div class="item-price">£{{ orderItems.frontDesk.price.toFixed(2) }}</div>
                </div>
                <div class="item-controls">
                  <button 
                    class="qty-btn" 
                    @click="decrementItem('frontDesk')"
                    :disabled="orderItems.frontDesk.quantity === 0"
                  >−</button>
                  <span class="qty-display">{{ orderItems.frontDesk.quantity }}</span>
                  <button class="qty-btn" @click="incrementItem('frontDesk')">+</button>
                </div>
              </div>

              <!-- Mirror Stickers -->
              <div class="order-item" :class="{ 'item-selected': orderItems.mirrorStickers.quantity > 0 }">
                <div class="item-image" @click="openImageLightbox(require('@/assets/stickerrounded.webp'))" style="cursor: pointer;">
                  <img src="../assets/stickerrounded.webp" alt="Mirror Stickers">
                </div>
                <div class="item-details">
                  <h3 class="item-name">"No Glue" Mirror Stickers</h3>
                  <p class="item-description">Removable stickers for client mirrors (12cm x 8cm)</p>
                  <div class="item-price">£{{ orderItems.mirrorStickers.price.toFixed(2) }}</div>
                </div>
                <div class="item-controls">
                  <button 
                    class="qty-btn" 
                    @click="decrementItem('mirrorStickers')"
                    :disabled="orderItems.mirrorStickers.quantity === 0"
                  >−</button>
                  <span class="qty-display">{{ orderItems.mirrorStickers.quantity }}</span>
                  <button class="qty-btn" @click="incrementItem('mirrorStickers')">+</button>
                </div>
              </div>

              <!-- Tabletop Stands -->
              <div class="order-item" :class="{ 'item-selected': orderItems.tabletopStands.quantity > 0 }">
                <div class="item-image" @click="openImageLightbox(require('@/assets/countersquare.webp'))" style="cursor: pointer;">
                  <img src="../assets/countersquaresm.webp" alt="Tabletop Stand">
                </div>
                <div class="item-details">
                  <h3 class="item-name">Tabletop Stand</h3>
                  <p class="item-description">Discreet stand for countertops (6cm x 4.3cm)</p>
                  <div class="item-price">£{{ orderItems.tabletopStands.price.toFixed(2) }}</div>
                </div>
                <div class="item-controls">
                  <button 
                    class="qty-btn" 
                    @click="decrementItem('tabletopStands')"
                    :disabled="orderItems.tabletopStands.quantity === 0"
                  >−</button>
                  <span class="qty-display">{{ orderItems.tabletopStands.quantity }}</span>
                  <button class="qty-btn" @click="incrementItem('tabletopStands')">+</button>
                </div>
              </div>
            </div>

            <!-- Order Summary -->
            <div class="order-summary" v-show="totalItems > 0">
              <div class="summary-row">
                <span>Items ({{ totalItems }})</span>
                <span>£{{ subtotal.toFixed(2) }}</span>
              </div>

              <div class="summary-row">
                <span>Postage &amp; Packaging</span>
                <span>£{{ postageAndPackaging.toFixed(2) }}</span>
              </div>

              <div class="summary-row total-row">
                <span>Total</span>
                <span class="total-amount">£{{ grandTotal.toFixed(2) }}</span>
              </div>
            </div>

            <!-- Configuration Options -->
            <div class="config-section">
              <h3 class="config-title">Configuration</h3>
              
              <select v-model="newOrderConfig.businessType" class="config-select">
                <option value="">Select your business type</option>
                <option value="salon">Salon</option>
                <option value="hotel">Hotel</option>
                <option value="restaurant">Restaurant</option>
                <option value="pub">Pub</option>
                <option value="other">Other</option>
              </select>

              <select v-model="newOrderConfig.recipientType" class="config-select">
                <option value="">Select description for recipients</option>
                <option value="stylist">Stylist</option>
                <option value="therapist">Therapist</option>
                <option value="technician">Technician</option>
                <option value="nailtechnician">Nail Technician</option>
                <option value="nailtech">Nail Tech</option>
                <option value="nailstylist">Nail Stylist</option>
                <option value="artist">Artist</option>
                <option value="host">Host</option>
                <option value="waiter">Waiter</option>
                <option value="barstaff">Bar Staff</option>
                <option value="driver">Driver</option>
                <option value="team">Team</option>
                <option value="guide">Guide</option>
                <option value="trainer">Trainer</option>
                <option value="non-specific">Non-specific</option>
              </select>

              <textarea 
                v-model="newOrderConfig.notes" 
                class="config-textarea"
                placeholder="Additional notes or special requirements"
              ></textarea>
            </div>

            <!-- Contact Information -->
            <div class="contact-section">
              <h3 class="config-title">Contact & Delivery Information</h3>
              
              <input 
                v-model="newOrderConfig.name"
                type="text" 
                class="config-input"
                placeholder="Your name"
              />

              <input 
                v-model="newOrderConfig.businessName"
                type="text" 
                class="config-input"
                placeholder="Business name"
              />

              <textarea 
                v-model="newOrderConfig.address"
                class="config-textarea"
                placeholder="Delivery address"
                rows="3"
              ></textarea>

              <input 
                v-model="newOrderConfig.email"
                type="email" 
                class="config-input"
                placeholder="Email address"
              />

              <input 
                v-model="newOrderConfig.phone"
                type="tel" 
                class="config-input"
                placeholder="Phone number (optional)"
              />

          <!-- REVIEW STEP (must be before Stripe UI) -->
          <div v-show="showOrderReview === true" class="order-summary" style="margin-top: 16px;">
            <div class="summary-row total-row" style="font-weight: 700;">
              <span>Review your order</span>
              <span>£{{ grandTotal.toFixed(2) }}</span>
            </div>

            <div class="summary-row">
              <span>Front Desk Stands</span>
              <span>{{ orderItems.frontDesk.quantity }}</span>
            </div>
            <div class="summary-row">
              <span>Mirror Stickers</span>
              <span>{{ orderItems.mirrorStickers.quantity }}</span>
            </div>
            <div class="summary-row">
              <span>Tabletop Stands</span>
              <span>{{ orderItems.tabletopStands.quantity }}</span>
            </div>

            <div class="summary-row">
              <span>Subtotal</span>
              <span>£{{ subtotal.toFixed(2) }}</span>
            </div>
            <div class="summary-row">
              <span>Postage &amp; Packaging</span>
              <span>£{{ postageAndPackaging.toFixed(2) }}</span>
            </div>

            <div class="summary-row total-row">
              <span>Total</span>
              <span class="total-amount">£{{ grandTotal.toFixed(2) }}</span>
            </div>

            <div style="margin-top: 14px;">
              <button class="submit-order-btn" type="button" @click="doConfirmAndShowPayment">
                Confirm &amp; Continue to Payment
              </button>

              <div style="margin-top: 10px;">
                <a href="#" @click.prevent="doBackToEditOrder">← Edit order</a>
              </div>
            </div>
          </div>

          <!-- Anchor for scroll -->
          <div id="payment-section-anchor"></div>
          <!-- Payment Information (only for paid orders) -->
          <div class="config-section" v-if="useNewOrderForm" v-show="totalItems > 0 && showOrderReview === true && showPaymentStep === true">
            <h3 class="config-title">Payment Information</h3>
            
            <!-- Apple Pay / Google Pay Button -->
            <div v-show="showPaymentRequestButton" style="margin-bottom: 16px;">
              <div id="payment-request-button"></div>
              <div style="text-align: center; margin: 12px 0; color: #6b7280; font-size: 14px;">
                — or pay with card —
              </div>
            </div>
            
            <!-- Regular Card Input -->
            <div id="card-element" class="config-input" style="padding: 14px;"></div>
            
            <p class="privacy-note" style="text-align: left; margin-top: 8px;">
              Your payment is securely processed by Stripe. We never see or store your card details.
            </p>
          </div>
          
          <p class="privacy-note">
            Your email and phone are <strong>never</strong> shared with anyone
          </p>
            </div>

            <!-- Submit Button -->
            <button
              class="submit-order-btn"
              :disabled="!canSubmitNewOrder"
              @click="doMainOrderButton()"
            >
              {{
                showOrderReview === true
                  ? `Pay - £${grandTotal.toFixed(2)}`
                  : `Review Order - £${grandTotal.toFixed(2)}`
              }}
            </button>

            <p class="contact-help">
              <strong>Questions?</strong> Call +442078560378 or email 
              <a href="mailto:mailorders@thanku.app">mailorders@thanku.app</a>
            </p>
          </div>
        </div>

        <!-- IMAGE LIGHTBOX -->
        <transition name="fade">
          <div v-show="showImageLightbox" class="image-lightbox-overlay" @click="closeLightbox">
            <div class="image-lightbox-content" @click.stop>
              <button class="lightbox-close-btn" @click="closeLightbox">×</button>
              <img :src="lightboxImageSrc" alt="Product Image" class="lightbox-image">
            </div>
          </div>
        </transition>

        <div
          v-show="this.showOrderCompleted === true"
          class="col-md-8 offset-md-2 tugreybluebox"
          style="margin-top: 3vw"
        >
          <div class="tufont tumediumtitlebold" style="padding-bottom: 2vw">
            Thank you for your order
          </div>

          <div class="tufont" style="padding-bottom: 1vw;">
            <strong>Confirmation number:</strong> {{ mediaOrderObjectId || '—' }}
          </div>

          <div ref="orderDiv">
            <OrderItem
              title="Package ordered"
              :orderItem="this.orderedPackage"
            />
            <OrderItem
              title="Business type"
              :orderItem="this.orderedBusinessType"
            />
            <OrderItem
              title="Description of main recipient"
              :orderItem="this.orderedDescriptionRecipient"
            />
            <OrderItem
              v-show="this.showStickers === true"
              title='Number of "No Glue" Mirror Stickers'
              :orderItem="this.orderedNumberOfStickers"
            />
            <OrderItem
              v-show="this.showTableTop === true"
              title="Number of Tabletop Stands"
              :orderItem="this.orderedNumberOfTabletopStands"
            />
            <OrderItem title="Order notes" :orderItem="this.orderedNotes" />
            <OrderItem title="Your name" :orderItem="this.orderedName" />
            <OrderItem
              title="Business name"
              :orderItem="this.orderedBusinessName"
            />
            <OrderItem
              title="Address to send media"
              :orderItem="this.orderedAddress"
            />
            <OrderItem title="Email" :orderItem="this.orderedEmail" />
            <OrderItem title="Phone" :orderItem="this.orderedPhoneNumber" />
          </div>

          <table style="width: 100%; margin-top: 2vw">
            <tr>
              <td style="display: flex">
                <div
                  class="lt-blue notes-text"
                  style="width: 60%; padding-top: 0vw; line-height: 1px"
                >
                  <b>Any questions?</b> Please call us on +442078560378 or email
                  us at
                  <a
                    href="mailto:mailorders@thanku.app?subject=get ThankU enquiry&body=Please let us know your query or requirements: %0D%0A%0D%0A%0D%0AThank you! best wishes, the ThankU Team"
                    >mailorders@thanku.app</a
                  >
                </div>
                <br />
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>
    <br />
      <HomeFooter
        @do-show-contact="doShowContactNew"
        @do-show-about="doShowAboutNew"
        @do-show-privacy="doShowPrivacyNew"
        @do-show-terms="doShowTermsNew"
      />
  </div>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js/pure';
const Parse = require("parse/node");
import shared from "../shared.js";
import LogRocket from "logrocket";

import { defineAsyncComponent } from "vue";

const NavigationBar = defineAsyncComponent({
  loader: () => import("../components/NavigationBar.vue"),
});

const HomePageTickedListItem = defineAsyncComponent({
  loader: () => import("../components/HomePageTickedListItem.vue"),
});

const OrderItem = defineAsyncComponent({
  loader: () => import("../components/OrderItem.vue"),
});

const HomeFooter = defineAsyncComponent({
  loader: () => import("../components/HomeFooter.vue"),
});

export default {
  inject: ["globalPushForwardInterval", "devEnv", "appId", "appJSKey"],
  data() {
    return {
      showPopUpOk: false,
      popUpMsgTitle: "",
      popUpMsgBody: "",
      fontSizeTitle: 2.7, // vh
      fontSizeTitleLineHeight: 5, //vh
      fontSizePopUpMsg: 2.3, // vh
      fontSizePopUpMsgLineHeight: 3.4, // vh

      fontSizeNormal: 3.0, // vh
      fontSizeNormalInPXToUse: "",
      fontSizeNormalLineHeight: 4.0, // vh
      fontSizeNormalInPXLineHeightToUse: "",
      nhbfmembers: false,
      // OLD FORM
      showStickers: true,
      showTableTop: false,
      showOrderForm: true,
      showOrderCompleted: false,
      orderedPackage: "",
      orderedBusinessType: "",
      orderedDescriptionRecipient: "",
      orderedNumberOfStickers: "",
      orderedNumberOfTabletopStands: "",
      orderedNotes: "",
      orderedName: "",
      orderedBusinessName: "",
      orderedAddress: "",
      orderedEmail: "",
      orderedPhoneNumber: "",
      
      // NEW FORM
      useNewOrderForm: false,
      orderItems: {
        frontDesk: { quantity: 0, price: 3.00 },
        mirrorStickers: { quantity: 0, price: 1.00 },
        tabletopStands: { quantity: 0, price: 4.00 }
      },
      newOrderConfig: {
        businessType: '',
        recipientType: '',
        notes: '',
        name: '',
        businessName: '',
        address: '',
        email: '',
        phone: ''
      },
      showImageLightbox: false,
      lightboxImageSrc: '',
      stripePublishableKey: process.env.VUE_APP_STRIPE_ENV === "dev" ? process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY_TEST : process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY_LIVE,
      
      // STRIPE OBJECTS
      stripe: null,
      cardElement: null,
      showPaymentRequestButton: false,
      showOrderReview: false,
      showPaymentStep: false,

      mediaOrderObjectId: null,
      lastPaymentIntentId: null,
    };
  },
  components: {
    NavigationBar,
    HomePageTickedListItem,
    HomeFooter,
    OrderItem,
  },
  computed: {
    frontdeskfull() {
      return require("@/assets/frontdeskfull.jpg");
    },
    stickerfull() {
      return require("@/assets/stickerfull.jpg");
    },
    countersquarefull() {
      return require("@/assets/countersquare.webp");
    },
    totalItems() {
      return this.orderItems.frontDesk.quantity + 
             this.orderItems.mirrorStickers.quantity + 
             this.orderItems.tabletopStands.quantity;
    },
    subtotal() {
      return (this.orderItems.frontDesk.quantity * this.orderItems.frontDesk.price) +
             (this.orderItems.mirrorStickers.quantity * this.orderItems.mirrorStickers.price) +
             (this.orderItems.tabletopStands.quantity * this.orderItems.tabletopStands.price);
    },
    canSubmitNewOrder() {
      return this.totalItems > 0 && 
             this.newOrderConfig.name && 
             this.newOrderConfig.businessName && 
             this.newOrderConfig.address && 
             this.newOrderConfig.email &&
             this.newOrderConfig.businessType &&
             this.newOrderConfig.recipientType;
    },
    postageAndPackaging() {
        // Only charge postage when there is at least 1 item
        return this.totalItems > 0 ? 0.99 : 0;
    },

    grandTotal() {
        return this.subtotal + this.postageAndPackaging;
    },
  },
  methods: {
    async tryInitStripeOnce() {
        // Only init Stripe when:
        // - we are in the paid form
        // - user has items
        // - user has confirmed and is on payment step
        // - card element not already created
        if (this.useNewOrderForm === true &&
            this.totalItems > 0 &&
            this.showOrderReview === true &&
            this.showPaymentStep === true &&
            !this.cardElement
        ) {
            await this.initializeStripeCardElement();
        }
    },
    doMainOrderButton() {
        // Step 1: go to review
        if (this.showOrderReview !== true) {
            this.doGoToOrderReview();
            return;
        }

        // Step 2: user confirmed review -> show payment UI
        if (this.showPaymentStep !== true) {
            this.doConfirmAndShowPayment();
            return;
        }

        // Step 3: payment step is visible -> card payment submit
        // Wallet users will use Apple/Google Pay buttons; card users use this.
        this.submitNewPaidOrder();
    },
    doGoToOrderReview() {
        if (!this.canSubmitNewOrder) {
            this.popUpMsgTitle = "Info required";
            this.popUpMsgBody = "Please complete all required fields and add at least one item to your order";
            this.showPopUpOk = true;
            return;
        }

        if (shared.validEmail(this.newOrderConfig.email) === false) {
            this.popUpMsgTitle = "Sorry";
            this.popUpMsgBody = this.newOrderConfig.email + " is not a valid email address";
            this.showPopUpOk = true;
            return;
        }

        this.showOrderReview = true;
        this.showPaymentStep = false;
    },

    doBackToEditOrder() {
        this.showOrderReview = false;
        this.showPaymentStep = false;
    },

    doConfirmAndShowPayment() {
        this.showPaymentStep = true;

        this.$nextTick(() => {
            try {
                // optional: scroll user down to the payment section
                const el = document.getElementById("payment-section-anchor");
                if (el && el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "start" });
            } catch (e) {}
        });
    },
    doToggleToPaidForm() {
      console.log("=== doToggleToPaidForm triggered ===");

      this.$router.replace({
        query: {
          ...this.$route.query,
          donew: 'true'
        }
      });

      this.useNewOrderForm = true;
    },
    async initializeStripeCardElement() {
      await this._loadStripeLibraryOnce();
      
      // Create Stripe instance ONCE and store it
      this.stripe = window.Stripe(this.stripePublishableKey);
      const elements = this.stripe.elements();
      
      // Create Payment Request for Apple Pay / Google Pay
      const paymentRequest = this.stripe.paymentRequest({
        country: 'GB',
        currency: 'gbp',
        total: {
          label: 'ThankU Media Order',
          amount: Math.round(this.grandTotal * 100),
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      // Check if Apple Pay or Google Pay is available
      const prButton = elements.create('paymentRequestButton', {
        paymentRequest: paymentRequest,
      });

      paymentRequest.canMakePayment().then((result) => {
        console.log('Payment Request availability:', result);
        if (result) {
          // Apple Pay or Google Pay is available
          console.log('Mounting payment request button for:', result.applePay ? 'Apple Pay' : 'Google Pay');
          prButton.mount('#payment-request-button');
          this.showPaymentRequestButton = true;
        } else {
          // Neither available
          console.log('No digital wallet payment methods available');
          this.showPaymentRequestButton = false;
        }
      }).catch((err) => {
        console.error('Error checking payment method availability:', err);
        this.showPaymentRequestButton = false;
      });

      // Handle the payment when user clicks Apple Pay / Google Pay
      paymentRequest.on('paymentmethod', async (ev) => {
        try {
          // Create payment intent
          const mediaOrderReturnJSON = await Parse.Cloud.run("createPaymentIntentForMediaOrder", this.returnStripeJSON());

          this.mediaOrderObjectId = mediaOrderReturnJSON.mediaOrderObjectId || null;
          this.lastPaymentIntentId = mediaOrderReturnJSON.strPaymentIntentId || null;

          // Confirm the payment with Apple/Google Pay
          const { error: confirmError } = await this.stripe.confirmCardPayment(
            mediaOrderReturnJSON.clientSecret,
            { payment_method: ev.paymentMethod.id },
          );

          if (confirmError) {
            ev.complete('fail');
            this.popUpMsgTitle = "Payment Failed";
            this.popUpMsgBody = confirmError.message;
            this.showPopUpOk = true;
          } else {
            ev.complete('success');
            // Payment successful!
            // Payment successful — finalise server-side (source of truth)
            try {
              if (this.lastPaymentIntentId) {
                const fin = await Parse.Cloud.run("finaliseMediaOrderPaymentIntent", {
                  paymentIntentId: this.lastPaymentIntentId
                });

                if (fin && fin.mediaOrderObjectId) {
                  this.mediaOrderObjectId = fin.mediaOrderObjectId;
                }
              }
            } catch (eFin) {
              console.error("Finalise failed (wallet):", eFin);
            }

            this.showOrderConfirmationScreen();
          }
        } catch (error) {
          ev.complete('fail');
          console.error("Payment error:", error);
          this.popUpMsgTitle = "Payment Error";
          this.popUpMsgBody = "There was an error processing your payment. Please try again.";
          this.showPopUpOk = true;
        }
      });

      // Create regular card element
      this.cardElement = elements.create('card', {
        style: {
          base: {
            fontSize: '16px',
            color: '#1a1a1a',
            '::placeholder': {
              color: '#9ca3af'
            }
          }
        }
      });
      
      this.cardElement.mount('#card-element');
    },
    _loadStripeLibraryOnce() {
        var self = this;
        return new Promise(function(resolve, reject) {
          try {
            if (typeof window !== "undefined" && window.Stripe && typeof window.Stripe === "function") {
              resolve({ loadedAt: new Date().toISOString(), version: self._detectStripeVersion() });
              console.log("Stripe successfully loaded")
              return;
            }
          } catch (e) {}
          try {
            if (typeof window !== "undefined" && window.__stripeSdkLoadingPromise) {
              window.__stripeSdkLoadingPromise.then(resolve).catch(reject);
              return;
            }
          } catch (e) {}

          var p = new Promise(function(res, rej) {
            try {
              var existing = document.getElementById("stripe-js");
              if (!existing) {
                var s = document.createElement("script");
                s.id = "stripe-js";
                s.src = "https://js.stripe.com/v3/";
                s.async = true;
                s.onload = function() {
                  try { res({ loadedAt: new Date().toISOString(), version: self._detectStripeVersion() }); }
                  catch (e2) { res({ loadedAt: new Date().toISOString(), version: "n/a" }); }
                };
                s.onerror = function() { rej(new Error("Stripe script onerror")); };
                document.head.appendChild(s);
              } else {
                window.setTimeout(function() {
                  try {
                    if (window.Stripe) { res({ loadedAt: new Date().toISOString(), version: self._detectStripeVersion() }); }
                    else { rej(new Error("Stripe tag exists but window.Stripe is undefined")); }
                  } catch (e3) {
                    rej(new Error("Stripe tag exists but access threw"));
                  }
                }, 0);
              }
            } catch (e) { rej(e); }
          });

          try { window.__stripeSdkLoadingPromise = p; } catch (e) {}
          p.then(resolve).catch(reject);
        });
      },

    _detectStripeVersion() {
      try {
        if (window && window.Stripe && window.Stripe.toString) {
          var s = String(window.Stripe.toString());
          return s.indexOf("[native code]") !== -1 ? "v3-native" : "present";
        }
      } catch (e) {}
      return "n/a";
    },

    returnStripeJSON(){
      return {
          amount: Math.round(this.grandTotal * 100), // Convert to pence, ensure integer
          currency: 'gbp',
          customerEmail: this.newOrderConfig.email,
          customerName: this.newOrderConfig.name,
          orderDetails: {
            frontDesk: this.orderItems.frontDesk.quantity,
            mirrorStickers: this.orderItems.mirrorStickers.quantity,
            tabletopStands: this.orderItems.tabletopStands.quantity,
            businessType: this.newOrderConfig.businessType,
            recipientType: this.newOrderConfig.recipientType,
            notes: this.newOrderConfig.notes,
            businessName: this.newOrderConfig.businessName,
            address: this.newOrderConfig.address,
            phone: this.newOrderConfig.phone
          }
        }
    },

    async submitNewPaidOrder() {

      console.log("submitting NEW order")
      if (!this.canSubmitNewOrder) {
        this.popUpMsgTitle = "Info required";
        this.popUpMsgBody = "Please complete all required fields and add at least one item to your order";
        this.showPopUpOk = true;
        return;
      }

      if (shared.validEmail(this.newOrderConfig.email) === false) {
        this.popUpMsgTitle = "Sorry";
        this.popUpMsgBody = this.newOrderConfig.email + " is not a valid email address";
        this.showPopUpOk = true;
        return;
      }

      try {
      
        // *** FIX: Use this.stripe instead of creating a new instance ***
        
        // Create payment intent via Parse Cloud Function
        const mediaOrderReturnJSON = await Parse.Cloud.run("createPaymentIntentForMediaOrder", this.returnStripeJSON());

        console.log("mediaOrderReturnJSON: <pre>" + JSON.stringify(mediaOrderReturnJSON, null,4) + "</pre>");

        this.mediaOrderObjectId = mediaOrderReturnJSON.mediaOrderObjectId || null;
        this.lastPaymentIntentId = mediaOrderReturnJSON.strPaymentIntentId || null;
        
        // *** FIX: Use this.stripe that was created in initializeStripeCardElement ***
        const { error, paymentIntent: confirmedPayment } = await this.stripe.confirmCardPayment(
          mediaOrderReturnJSON.clientSecret,
          {
            payment_method: {
              card: this.cardElement,
              billing_details: {
                name: this.newOrderConfig.name,
                email: this.newOrderConfig.email,
                address: {
                  line1: this.newOrderConfig.address
                }
              }
            }
          }
        );

        
        
        if (error) {
          // Payment failed
          this.popUpMsgTitle = "Payment Failed";
          this.popUpMsgBody = error.message;
          this.showPopUpOk = true;
          return;
        }
        
        // Payment successful!
        // Payment successful — finalise server-side (source of truth)
        

        try {
            const fin = await Parse.Cloud.run("finaliseMediaOrderPaymentIntent", {
                paymentIntentId: confirmedPayment.id
            });

            // If backend found and saved the row, we can trust the order id
            if (fin && fin.mediaOrderObjectId) {
                this.mediaOrderObjectId = fin.mediaOrderObjectId;
            }

        } catch (eFin) {
            // Don't block UX, but this is important — your backend already emails appalert on failure
            console.error("Finalise failed:", eFin);
        }

        this.showOrderConfirmationScreen();
        
      } catch (error) {
        console.error("Payment error:", error);
        this.popUpMsgTitle = "Payment Error";
        this.popUpMsgBody = "There was an error processing your payment. Please try again.";
        this.showPopUpOk = true;
      }
    },

    showOrderConfirmationScreen() {
      this.showOrderForm = false;
      this.showOrderReview = false;
      this.showPaymentStep = false;
      this.showOrderCompleted = true;
    },

    // NEW ORDER FORM METHODS
    openImageLightbox(imageSrc) {
      this.lightboxImageSrc = imageSrc;
      this.showImageLightbox = true;
    },
    closeLightbox() {
      this.showImageLightbox = false;
      this.lightboxImageSrc = '';
    },
    incrementItem(itemKey) {
      this.orderItems[itemKey].quantity++;
    },
    decrementItem(itemKey) {
      if (this.orderItems[itemKey].quantity > 0) {
        this.orderItems[itemKey].quantity--;
      }
    },
    // submitNewOrder() {
    //   if (!this.canSubmitNewOrder) {
    //     this.popUpMsgTitle = "Info required";
    //     this.popUpMsgBody = "Please complete all required fields and add at least one item to your order";
    //     this.showPopUpOk = true;
    //     return;
    //   }

    //   if (shared.validEmail(this.newOrderConfig.email) === false) {
    //     this.popUpMsgTitle = "Sorry";
    //     this.popUpMsgBody = this.newOrderConfig.email + " is not a valid email address";
    //     this.showPopUpOk = true;
    //     return;
    //   }

    //   // Prepare order summary
    //   this.orderedPackage = "Custom Order";
    //   this.orderedBusinessType = this.newOrderConfig.businessType;
    //   this.orderedDescriptionRecipient = this.newOrderConfig.recipientType;
    //   this.orderedNumberOfStickers = this.orderItems.mirrorStickers.quantity.toString();
    //   this.orderedNumberOfTabletopStands = this.orderItems.tabletopStands.quantity.toString();
    //   this.orderedNotes = this.newOrderConfig.notes;
    //   this.orderedName = this.newOrderConfig.name;
    //   this.orderedBusinessName = this.newOrderConfig.businessName;
    //   this.orderedAddress = this.newOrderConfig.address;
    //   this.orderedEmail = this.newOrderConfig.email;
    //   this.orderedPhoneNumber = this.newOrderConfig.phone;

    //   this.showOrderForm = false;
    //   this.showOrderCompleted = true;

    //   this.$nextTick(() => {
    //     let mailHTML = '<table border=0 style="padding-top: 4px; padding-bottom: 4px"><tr>' +
    //       '<td style="width: 40%"><strong>NEW ORDER FORM</strong></td><td></td></tr><tr>' +
    //       '<td>Front Desk Stands:</td><td>' + this.orderItems.frontDesk.quantity + ' @ £' + 
    //       this.orderItems.frontDesk.price.toFixed(2) + ' each</td></tr><tr>' +
    //       '<td>Mirror Stickers:</td><td>' + this.orderItems.mirrorStickers.quantity + ' @ £' + 
    //       this.orderItems.mirrorStickers.price.toFixed(2) + ' each</td></tr><tr>' +
    //       '<td>Tabletop Stands:</td><td>' + this.orderItems.tabletopStands.quantity + ' @ £' + 
    //       this.orderItems.tabletopStands.price.toFixed(2) + ' each</td></tr><tr>' +
    //       '<td><strong>Subtotal:</strong></td><td><strong>£' + this.subtotal.toFixed(2) + '</strong></td></tr><tr>' +
    //       '<td>Business type:</td><td>' + this.orderedBusinessType + '</td></tr><tr>' +
    //       '<td>Recipient type:</td><td>' + this.orderedDescriptionRecipient + '</td></tr><tr>' +
    //       '<td>Notes:</td><td>' + this.orderedNotes + '</td></tr><tr>' +
    //       '<td>Name:</td><td>' + this.orderedName + '</td></tr><tr>' +
    //       '<td>Business name:</td><td>' + this.orderedBusinessName + '</td></tr><tr>' +
    //       '<td>Address:</td><td>' + this.orderedAddress + '</td></tr><tr>' +
    //       '<td>Email:</td><td>' + this.orderedEmail + '</td></tr><tr>' +
    //       '<td>Phone:</td><td>' + this.orderedPhoneNumber + '</td></tr></table>';

    //     const params = {
    //       toEmail: this.orderedEmail,
    //       subject: "We have received your order for ThankU Cashless Tipping QR media",
    //       body: mailHTML,
    //       orderName: this.orderedName,
    //       sgTemplateName: "sendMediaOrderedEmail2024",
    //     };

    //     Parse.Cloud.run("sendEmail", params);

    //     const params2 = {
    //       toEmail: "appalert@thanku.app",
    //       subject: "ThankU ORDER RECEIVED (NEW FORM)",
    //       body: mailHTML,
    //     };

    //     Parse.Cloud.run("sendEmail", params2);
    //   });
    // },

    // OLD METHODS
    doShowHome() {
      console.log("ok let's doShowHome NEW");
      let returnJSON = { showHomeNew: true, fromScreen: "getTipsStartNew" };
      this.$emit("return-json", returnJSON);
    },
    doShowAccount(){
      console.log("ok let's doShowAccount");
      let returnJSON = { showAccount: true, fromScreen: "getTipsStartNew"  };
      this.$emit('return-json', returnJSON);
    },
    doShowTipWithoutScanning(){
      let returnJSON = { showTipWithoutScanning: true, fromScreen: "getTipsStartNew" };
      this.$emit('return-json', returnJSON);
    },
    doGiveTipsShowMoreInfoNew() {
      console.log("show more info NEW! .. on doGiveTipsShowMoreInfoNew");
      let returnJSON = {
        showMoreGiveInfoNew: true,
        fromScreen: "getTipsStartNew",
      };
      this.$emit("return-json", returnJSON);
    },
    doGetTipsShowMoreInfoNew() {
      console.log("show more info NEW! .. on doGetTipsShowMoreInfoNew");
      let returnJSON = {
        showMoreGetInfoNew: true,
        fromScreen: "getTipsStartNew",
      };
      this.$emit("return-json", returnJSON);
    },
    doGetTipsShowMoreInfoFeesNew() {
      console.log("show more info plus fees NEW!");
      let returnJSON = {
        showMoreGetInfoNew: true,
        feesShow: true,
        fromScreen: "getTipsStartNew",
      };
      this.$emit("return-json", returnJSON);
    },
    doShowContactNew() {
      let returnJSON = { showContactNew: true, fromScreen: "getTipsStartNew" };
      this.$emit("return-json", returnJSON);
    },
    doPopUpOk() {
      this.showPopUpOk = false;
    },
    doDetectSelectChangePackage() {
      let orderPackage = this.$refs.changePackage.value;
      if (orderPackage === "regular") {
        this.showStickers = true;
        this.showTableTop = false;
      } else if (orderPackage === "discreet") {
        this.showStickers = false;
        this.showTableTop = true;
      } else {
        this.showStickers = true;
        this.showTableTop = true;
      }
    },
    doSubmitOrder() {
      console.log("submitting order");

      if (this.$refs.orderName.value === "") {
        this.popUpMsgTitle = "Info required";
        this.popUpMsgBody =
          "Please provide your name so we can contact you, if necessary, about your order";
        this.showPopUpOk = true;
      } else if (this.$refs.orderBusinessName.value === "") {
        this.popUpMsgTitle = "Info required";
        this.popUpMsgBody =
          "Please provide your business name - normally the name of your brand as it will be shown on thankU";
        this.showPopUpOk = true;
      } else if (this.$refs.orderAddress.value === "") {
        this.popUpMsgTitle = "Info required";
        this.popUpMsgBody =
          "Please provide the address you would like us to send your ThankU QR media package to";
        this.showPopUpOk = true;
      } else if (this.$refs.orderEmail.value === "") {
        this.popUpMsgTitle = "Info required";
        this.popUpMsgBody =
          "Please provide your email so that we can update you on your order";
        this.showPopUpOk = true;
      } else if (shared.validEmail(this.$refs.orderEmail.value) === false) {
        this.popUpMsgTitle = "Sorry";
        this.popUpMsgBody =
          this.$refs.orderEmail.value + " is not a valid email address";
        this.showPopUpOk = true;
      } else {
        this.orderedPackage =
          this.$refs.changePackage.selectedIndex === 0
            ? this.$refs.changePackage.options[1].text
            : this.$refs.changePackage.options[
                this.$refs.changePackage.selectedIndex
              ].text;
        this.orderedBusinessType =
          this.$refs.changeBusinessType.selectedIndex === 0
            ? this.$refs.changeBusinessType.options[1].text
            : this.$refs.changeBusinessType.options[
                this.$refs.changeBusinessType.selectedIndex
              ].text;
        this.orderedDescriptionRecipient =
          this.$refs.changeDescriptionRecipient.selectedIndex === 0
            ? this.$refs.changeDescriptionRecipient.options[1].text
            : this.$refs.changeDescriptionRecipient.options[
                this.$refs.changeDescriptionRecipient.selectedIndex
              ].text;
        this.orderedNumberOfStickers =
          this.$refs.changeNumberOfStickers.value === "31"
            ? "more than 30"
            : this.$refs.changeNumberOfStickers.value;
        this.orderedNumberOfTabletopStands =
          this.$refs.changeNumberOfTabletopStands.value === "4"
            ? "more than 3"
            : this.$refs.changeNumberOfTabletopStands.value;
        this.orderedNotes = this.$refs.orderNotes.value;
        this.orderedName = this.$refs.orderName.value;
        this.orderedBusinessName = this.$refs.orderBusinessName.value;
        this.orderedAddress = this.$refs.orderAddress.value;
        this.orderedEmail = this.$refs.orderEmail.value;
        this.orderedPhoneNumber = this.$refs.orderPhoneNumber.value;

        this.showOrderForm = false;
        this.showOrderCompleted = true;

        this.$nextTick(() => {
          let mailHTML =
            '<table border=0 style="padding-top: 4px; padding-bottom: 4px"><tr>' +
            '<td style="width: 40%">Package ordered:</td><td style="width: 60%">' +
            this.orderedPackage +
            "</td></tr><tr>" +
            "<td>Business type:</td><td>" +
            this.orderedBusinessType +
            "</td></tr><tr>" +
            "<td>Description of main recipient:</td><td>" +
            this.orderedDescriptionRecipient +
            "</td></tr><tr>";

          if (this.showStickers === true) {
            mailHTML +=
              '<td>Number of "No Glue" Mirror Stickers:</td><td>' +
              this.orderedNumberOfStickers +
              "</td></tr><tr>";
          }

          if (this.showTableTop === true) {
            mailHTML +=
              "<td>Number of Tabletop Stands:</td><td>" +
              this.orderedNumberOfTabletopStands +
              "</td></tr><tr>";
          }

          mailHTML +=
            "<td>Order notes:</td><td>" +
            this.orderedNotes +
            "</td></tr><tr>" +
            "<td>Your name:</td><td>" +
            this.orderedName +
            "</td></tr><tr>" +
            "<td>Business name:</td><td>" +
            this.orderedBusinessName +
            "</td></tr><tr>" +
            "<td>Address to send media:</td><td>" +
            this.orderedAddress +
            "</td></tr><tr>" +
            "<td>Email:</td><td>" +
            this.orderedEmail +
            "</td></tr><tr>" +
            "<td>Phone:</td><td>" +
            this.orderedPhoneNumber +
            "</td></tr></table>";

          const params = {
            toEmail: this.orderedEmail,
            subject:
              "We have received your order for ThankU Cashless Tipping QR media",
            body: mailHTML,
            orderName: this.orderedName,
            sgTemplateName: "sendMediaOrderedEmail2024",
          };

          Parse.Cloud.run("sendEmail", params);

          const params2 = {
            toEmail: "appalert@thanku.app",
            subject: "ThankU ORDER RECEIVED",
            body: this.$refs.orderDiv.outerHTML,
          };

          Parse.Cloud.run("sendEmail", params2);
        });
      }
    },
    doFontSizeComputed() {
      this.fontSizeNormalInPXToUse = shared.convertVHSizeToMaxPixelsSize(
        this.fontSizeNormal,
        16
      );
      this.fontSizeNormalInPXLineHeightToUse =
        shared.convertVHSizeToMaxPixelsSize(this.fontSizeNormalLineHeight, 20);
    },
    doOrderBadges() {
      console.log("TAKE MY ORDER!");
      this.$refs.orderForm.scrollIntoView({ block: "start" });
    },
    doShowGetTipsStartNew() {
      console.log("TAKE MY ORDER!");
      this.$refs.orderForm.scrollIntoView({ block: "start" });
    },
    doDownloadBrochure() {
      const url = "https://www.thanku.app/introtothanku.pdf";

      let LRObjectId = undefined;

      if (window.localStorage.getItem("tuob") !== null) {
        LRObjectId = window.localStorage.getItem("tuob");
      } else if (
        window.localStorage.getItem("logRocketUserTimeStampId") !== null
      ) {
        LRObjectId = window.localStorage.getItem("logRocketUserTimeStampId");
      } else {
        window.localStorage.setItem(
          "logRocketUserTimeStampId",
          new Date().getTime()
        );
        LRObjectId = window.localStorage.getItem("logRocketUserTimeStampId");
      }

      let googleAdsOriginalReferrerURL =
        window.localStorage.getItem("googleAdsOriginalReferrerURL") !==
        undefined
          ? window.localStorage.getItem("googleAdsOriginalReferrerURL")
          : "n/a";

      const params = {
        toEmail: "appalert@thanku.app",
        subject:
          "GREAT! Someone downloaded ThankU pdf brochure on NEW ORDER PAGE",
        body: {
          type: "TappedDownloadThankUBrochure",
          googleAdsOriginalReferrerURL: googleAdsOriginalReferrerURL,
          referrerURL: window.localStorage.getItem("referrerURL"),
          LRObjectId: LRObjectId,
        },
      };

      Parse.Cloud.run("sendEmail", params);

      window.open(url, "_self");
    },
    doShowHolding() {
      shared.saveToUserPath(
        this.devEnv,
        "User wanted to start get tips process " + new Date().toISOString(),
        this.globalPushForwardInterval
      );
      this.popUpMsgTitle = "Sorry";
      this.popUpMsgBody =
        "This bit is not ready yet - for the time being please just email us at mediaorders@thanku.app and let us know what type of business you have and how many people will receive tips at it";
      this.showPopUpOk = true;
    },
    doRecipientSelected() {
      let returnJSON = {
        selectedTUID: "00000000002",
      };
      this.$emit("return-json", returnJSON);
    },
    goBack() {
      if (window.localStorage.getItem("nextScreen") !== null && window.localStorage.getItem("nextScreen") !== undefined) {
        let returnJSON = {
          nextScreen: window.localStorage.getItem("nextScreen"),
        };
        this.$emit("return-json", returnJSON);
        window.localStorage.removeItem("nextScreen");
      } else {
        let returnJSON = { showHome: true, };
        this.$emit("return-json", returnJSON);
      }
    },
    doSetMetas() {
      const title = this.useNewOrderForm ? 
        "Order ThankU Cashless Tipping QR badges" : 
        "Get free ThankU Cashless Tipping QR badges";
      
      const description = this.useNewOrderForm ?
        "Order your ThankU Cashless Tipping QR badges - select from our range of stands and stickers, configure for your business, and complete your order online." :
        "Get free ThankU Cashless Tipping QR badges - our stand-mounted ThankU QR badges are just 6x4x2cm. They sit at the front desk and at your client seats (at your option). Simply tap the 'Order ThankU badges' button below, tell us which design/colour you like (1, 2, or 3), how many you need, and the address to send them to - that's it!";

      document.title = title;
      document
        .getElementsByTagName("meta")
        .namedItem("description")
        .setAttribute("content", description);
    },
    async deployLogRocket() {
      var LRObjectId = new Date().getTime();

      if (window.localStorage.getItem("tuob") !== null) {
        LRObjectId = window.localStorage.getItem("tuob");
      }

      if (LRObjectId === "4g278vWUb1" || LRObjectId === "2fBkimFcIw") {
        return;
      }

      var LRDisplayname = "LR Name not given";

      if (window.localStorage.getItem("tudis") !== null) {
        LRDisplayname = window.localStorage.getItem("tudis");
      }

      try {
        LogRocket.identify(LRObjectId, {
          name: LRDisplayname + ": get started",
          email: undefined,
        });
      } catch (e) {
        const params = {
          toEmail: "appalert@thanku.app",
          subject: "ALERT! LogRocket initialisation error: " + e.message,
          body: "ALERT! LogRocket initialisation error: " + e.message,
        };

        Parse.Cloud.run("sendEmail", params);
      }
    },
    startParse(){
      Parse.serverURL = "https://parseapi.back4app.com/";
      Parse.initialize(this.appId, this.appJSKey);
      console.log("initialised Parse");
    },
    checkUrlParams() {
      console.log('=== CHECKING URL PARAMS ===');
      console.log('Full URL:', window.location.href);
      console.log('Vue Route:', this.$route);
      
      // Method 0: Check Vue Router query params (PRIMARY - this is where they'll be)
      let routeParamValue = null;
      if (this.$route && this.$route.query) {
        routeParamValue = this.$route.query.donew;
        console.log('Method 0 - Vue Router query (PRIMARY):', routeParamValue);
        console.log('Full route query:', this.$route.query);
      }
      
      // Method 1: Check URLSearchParams from window.location
      const urlParams = new URLSearchParams(window.location.search);
      const urlParamValue = urlParams.get('donew');
      console.log('Method 1 - URLSearchParams:', urlParamValue);
      
      // Method 2: Check hash location for query params
      const hash = window.location.hash;
      console.log('Hash:', hash);
      let hashParamValue = null;
      if (hash.includes('?')) {
        const hashParams = new URLSearchParams(hash.split('?')[1]);
        hashParamValue = hashParams.get('donew');
        console.log('Method 2 - Hash params:', hashParamValue);
      }
      
      console.log('BEFORE setting - this.useNewOrderForm:', this.useNewOrderForm);
      console.log('Setting based on:', { routeParamValue, urlParamValue, hashParamValue });
      
      // Set useNewOrderForm if any method finds donew=true
      // Handle both boolean true and string 'true'
      // Check Vue Router query first as it's the most reliable in your setup
      this.useNewOrderForm = routeParamValue === 'true' || routeParamValue === true ||
                            urlParamValue === 'true' || urlParamValue === true || 
                            hashParamValue === 'true' || hashParamValue === true;
      
      console.log('AFTER setting - this.useNewOrderForm:', this.useNewOrderForm);
      
      console.log('Final useNewOrderForm value:', this.useNewOrderForm);
      console.log('=========================');
    }
  },
  created() {
    console.log("creating me!");
    console.log("Route object:", this.$route);
    console.log("Full URL:", window.location.href);
    
    this.checkUrlParams();
    
    this.deployLogRocket();
    document.body.style.maxWidth = "100vw";
    this.doSetMetas();

    const fromScreen =
      this.$route.params !== undefined
        ? " from " + this.$route.params.fromScreen
        : this.fromScreen !== undefined
        ? this.fromScreen
        : "";

    let referrerURL =
      window.localStorage.getItem("referrerURL") !== null
        ? window.localStorage.getItem("referrerURL")
        : "";

    var extraMsg = "";

    if (window.localStorage.getItem("isnhbfmember") !== null) {
      window.localStorage.removeItem("isnhbfmember");
      this.nhbfmembers = true;
      extraMsg = "FOR NHBF MEMBER ";
    }
    shared.saveToUserPath(
      this.devEnv,
      "Get tips start process " + extraMsg + new Date().toISOString(),
      this.globalPushForwardInterval
    );
    this.doFontSizeComputed();
    window.addEventListener("resize", this.doFontSizeComputed);
  },
  mounted() {
    console.log("MOUNTME!");
    // Check URL params again in mounted hook in case routing happened after created
    this.checkUrlParams();
    window.setTimeout(this.startParse, 1000);
    window.scrollTo(0, 0);

  },
  watch: {
      totalItems() {
          this.tryInitStripeOnce();
      },
      useNewOrderForm() {
          this.tryInitStripeOnce();
      },
      showPaymentStep() {
          this.tryInitStripeOnce();
      }
  },
};
</script>

<style>

html, body{
  overflow-x: hidden !important;
  max-width: 100vw !important;
  touch-action: pan-y;
}

/* NEW ORDER FORM STYLES */
.new-order-form-container {
  width: 100%;
  max-width: 800px;
  margin: 3vw auto;
  padding: 0 16px;
}

.new-order-form {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 20px;
  padding: clamp(20px, 4vw, 40px);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.form-title {
  font-family: 'Georgia', serif;
  font-size: clamp(24px, 5vw, 32px);
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: clamp(20px, 4vw, 32px);
  text-align: center;
  letter-spacing: -0.5px;
}

.order-items {
  display: flex;
  flex-direction: column;
  gap: clamp(12px, 2vw, 16px);
  margin-bottom: clamp(20px, 3vw, 24px);
}

/* MOBILE-FIRST: Vertical Stack Layout */
@media (max-width: 575.98px) {
  .order-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: clamp(12px, 3vw, 16px);
    background: white;
    border-radius: 12px;
    padding: clamp(16px, 4vw, 20px);
    border: 2px solid #e5e7eb;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .item-image {
    flex-shrink: 0;
    width: clamp(100px, 25vw, 120px);
    height: clamp(100px, 25vw, 120px);
    border-radius: 12px;
    overflow: hidden;
    background: #f3f4f6;
    margin-bottom: 8px;
    transition: transform 0.2s;
  }

  .item-image:hover {
    transform: scale(1.05);
  }

  .item-details {
    flex: none;
    width: 100%;
    min-width: 0;
  }

  .item-name {
    font-family: 'Georgia', serif;
    font-size: clamp(18px, 4.5vw, 22px);
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 8px 0;
  }

  .item-description {
    font-size: clamp(13px, 3.2vw, 15px);
    color: #6b7280;
    margin: 0 0 8px 0;
    line-height: 1.5;
  }

  .item-price {
    font-size: clamp(16px, 4vw, 20px);
    font-weight: 700;
    color: #6366f1;
    margin-bottom: 12px;
  }

  .item-controls {
    display: flex;
    align-items: center;
    gap: clamp(10px, 2.5vw, 12px);
    flex-shrink: 0;
    justify-content: center;
  }

  .qty-btn {
    width: clamp(44px, 11vw, 48px);
    height: clamp(44px, 11vw, 48px);
    border: none;
    border-radius: 12px;
    background: #6366f1;
    color: white;
    font-size: clamp(20px, 5vw, 24px);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qty-display {
    font-size: clamp(18px, 4.5vw, 22px);
    font-weight: 600;
    color: #1a1a1a;
    min-width: clamp(32px, 8vw, 40px);
    text-align: center;
  }
}

/* DESKTOP: Horizontal Row Layout */
@media (min-width: 576px) {
  .order-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: clamp(12px, 2vw, 16px);
    background: white;
    border-radius: 12px;
    padding: clamp(12px, 2vw, 16px);
    border: 2px solid #e5e7eb;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .item-image {
    flex-shrink: 0;
    width: clamp(60px, 15vw, 80px);
    height: clamp(60px, 15vw, 80px);
    border-radius: 8px;
    overflow: hidden;
    background: #f3f4f6;
    transition: transform 0.2s;
  }

  .item-image:hover {
    transform: scale(1.05);
  }

  .item-details {
    flex: 1;
    min-width: 0;
    text-align: left;
  }

  .item-name {
    font-family: 'Georgia', serif;
    font-size: clamp(14px, 3vw, 16px);
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 4px 0;
  }

  .item-description {
    font-size: clamp(11px, 2.5vw, 13px);
    color: #6b7280;
    margin: 0 0 6px 0;
    line-height: 1.4;
  }

  .item-price {
    font-size: clamp(13px, 2.8vw, 15px);
    font-weight: 700;
    color: #6366f1;
  }

  .item-controls {
    display: flex;
    align-items: center;
    gap: clamp(6px, 1.5vw, 8px);
    flex-shrink: 0;
  }

  .qty-btn {
    width: clamp(32px, 8vw, 36px);
    height: clamp(32px, 8vw, 36px);
    border: none;
    border-radius: 8px;
    background: #6366f1;
    color: white;
    font-size: clamp(16px, 4vw, 20px);
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qty-display {
    font-size: clamp(14px, 3.5vw, 16px);
    font-weight: 600;
    color: #1a1a1a;
    min-width: clamp(20px, 5vw, 24px);
    text-align: center;
  }
}

/* SHARED STYLES FOR ALL SCREEN SIZES */
.order-item:hover {
  border-color: #6366f1;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1);
  transform: translateY(-2px);
}

.order-item.item-selected {
  border-color: #6366f1;
  background: linear-gradient(135deg, #faf5ff 0%, #ffffff 100%);
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qty-btn:hover:not(:disabled) {
  background: #4f46e5;
  transform: scale(1.05);
}

.qty-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.qty-btn:disabled {
  background: #e5e7eb;
  cursor: not-allowed;
  opacity: 0.5;
}

.order-summary {
  background: linear-gradient(135deg, #faf5ff 0%, #f3f4f6 100%);
  border-radius: 12px;
  padding: clamp(16px, 3vw, 20px);
  margin-bottom: clamp(20px, 3vw, 24px);
  border: 2px solid #e5e7eb;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: clamp(13px, 3vw, 15px);
  color: #6b7280;
  margin-bottom: 8px;
}

.summary-row:last-child {
  margin-bottom: 0;
}

.total-row {
  padding-top: 12px;
  border-top: 2px solid #e5e7eb;
  margin-top: 8px;
  font-size: clamp(15px, 3.5vw, 18px);
  font-weight: 600;
  color: #1a1a1a;
}

.total-amount {
  font-size: clamp(18px, 4vw, 24px);
  color: #6366f1;
  font-weight: 700;
}

.config-section,
.contact-section {
  margin-bottom: clamp(20px, 3vw, 24px);
}

.config-title {
  font-family: 'Georgia', serif;
  font-size: clamp(16px, 3.5vw, 18px);
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: clamp(12px, 2vw, 16px);
}

.config-select,
.config-input,
.config-textarea {
  width: 100%;
  padding: clamp(12px, 2.5vw, 14px);
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: clamp(13px, 3vw, 15px);
  color: #1a1a1a;
  background: white;
  margin-bottom: clamp(10px, 2vw, 12px);
  transition: all 0.2s;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.config-select:focus,
.config-input:focus,
.config-textarea:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.config-textarea {
  min-height: clamp(80px, 15vw, 100px);
  resize: vertical;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.privacy-note {
  font-size: clamp(11px, 2.5vw, 13px);
  color: #6b7280;
  margin: clamp(8px, 1.5vw, 12px) 0 0 0;
  text-align: center;
}

.submit-order-btn {
  width: 100%;
  padding: clamp(14px, 3vw, 18px);
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  font-size: clamp(15px, 3.5vw, 18px);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
  margin-bottom: clamp(12px, 2vw, 16px);
}

.submit-order-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
}

.submit-order-btn:active:not(:disabled) {
  transform: translateY(0);
}

.submit-order-btn:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
  box-shadow: none;
}

.contact-help {
  font-size: clamp(12px, 2.8vw, 14px);
  color: #6b7280;
  text-align: center;
  margin: 0;
  line-height: 1.6;
}

.contact-help a {
  color: #6366f1;
  text-decoration: none;
  font-weight: 500;
}

.contact-help a:hover {
  text-decoration: underline;
}

/* EXISTING STYLES */
@media (max-width: 575.98px) {
  .hairdresser2imagewidth {
    width: 100%;
  }

  .productImageWidth {
    width: 80%;
  }

  .productImageWidthCountertop {
    width: 80%;
  }

  .discreetpackagephonewidth {
    margin: auto !important;
    width: 90vw !important;
  }

  .orderformphonewidth {
    margin: auto !important;
    width: 90vw !important;
  }

  .tugettipspagebuttonwidth {
    width: 80% !important;
  }

  .tugettipspage-textbox {
    margin: auto;
    font-size: 16px;
    height: clamp(24px, 5vh, 34px);
    padding-left: 12px;
    border:0.3px solid #b9b9c0;
    border-radius: 10px;
  }
}

@media (min-width: 576px) {
  .hairdresser2imagewidth {
    width: 80%;
  }

  .productImageWidth {
    width: 80%;
  }

  .productImageWidthCountertop {
    width: 83%;
  }

  .tugettipspagebuttonwidth {
    width: 50% !important;
  }

  .tugettipspage-textbox {
    margin: auto;
    font-size: 16px;
    height: 5vh;
    padding-left: 12px;
    border:0.3px solid #b9b9c0;
    border-radius: 10px;
  }
}

/* IMAGE LIGHTBOX STYLES */
.image-lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.image-lightbox-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
}

.lightbox-close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
  color: #333;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 10001;
}

.lightbox-close-btn:hover {
  background: #f3f4f6;
  transform: scale(1.1);
}

/* Fade transition for lightbox */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* EXISTING STYLES */
@media (max-width: 575.98px) {
  .hairdresser2imagewidth {
    width: 100%;
  }

  .productImageWidth {
    width: 80%;
  }

  .productImageWidthCountertop {
    width: 80%;
  }

  .discreetpackagephonewidth {
    margin: auto !important;
    width: 90vw !important;
  }

  .orderformphonewidth {
    margin: auto !important;
    width: 90vw !important;
  }

  .tugettipspagebuttonwidth {
    width: 80% !important;
  }

  .tugettipspage-textbox {
    margin: auto;
    font-size: 16px;
    height: clamp(24px, 5vh, 34px);
    padding-left: 12px;
    border:0.3px solid #b9b9c0;
    border-radius: 10px;
  }
}

@media (min-width: 576px) {
  .hairdresser2imagewidth {
    width: 80%;
  }

  .productImageWidth {
    width: 80%;
  }

  .productImageWidthCountertop {
    width: 83%;
  }

  .tugettipspagebuttonwidth {
    width: 50% !important;
  }

  .tugettipspage-textbox {
    margin: auto;
    font-size: 16px;
    height: 5vh;
    padding-left: 12px;
    border:0.3px solid #b9b9c0;
    border-radius: 10px;
  }
}

/* IMAGE LIGHTBOX STYLES */
.image-lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.image-lightbox-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
}

.lightbox-close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
  color: #333;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 10001;
}

.lightbox-close-btn:hover {
  background: #f3f4f6;
  transform: scale(1.1);
}

/* Fade transition for lightbox */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.item-image {
  transition: transform 0.2s;
}

.item-image:hover {
  transform: scale(1.05);
}

/* Apple Pay / Google Pay Button Styling */
#payment-request-button {
  height: 44px;
}

#payment-request-button button {
  height: 44px !important;
  border-radius: 10px !important;
}
</style>